import React, { useState } from "react";
import { scrollBar } from "Components/Common/Header/ManageOutsideClickClose";
import { useTranslation } from "react-i18next";
import "./style.css";
import { useTranslationCheck } from "Hooks/useTranslationCheck";

interface TableProps {
  title: string;
  data: any[];
}

const Table: React.FC<TableProps> = ({ title, data }) => {
  const { t, tCheck } = useTranslationCheck();
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const [orderBy, setOrderBy] = useState<string>("id");
  const [statusIsASC, setStatusIsASC] = useState<boolean>(true);

  const toggleSort = (field: string, isAcs: boolean) => {
    if (field !== "id") {
      setStatusIsASC(!isAcs);
      setOrderBy(isAcs ? field : "-" + field);
    }
  };

  scrollBar(setIsScrolling);

  const calculateSubtotal = () => {
    const subtotal = {
      footprint: 0.0,
      totalfootprint: 0.0,
      totalco2emission: 0.0,
    };

    data.forEach((row) => {
      // Parse values correctly according to their columns
      subtotal.footprint += parseFloat(row.footprint) || 0;
      subtotal.totalfootprint += parseFloat(row.totalfootprint) || 0;

      // Handle percentage values by removing % and converting to number
      const co2Value = parseFloat(row.totalco2emission.replace("%", "")) || 0;
      subtotal.totalco2emission += co2Value;
    });

    return {
      footprint: roundToTwoDecimals(subtotal.footprint),
      totalfootprint: roundToTwoDecimals(subtotal.totalfootprint),
      totalco2emission: `${roundToTwoDecimals(subtotal.totalco2emission)}%`,
    };
  };

  // Helper function for consistent rounding
  const roundToTwoDecimals = (num: number): number => {
    return Number(Math.round(num * 100) / 100);
  };

  const subtotal = calculateSubtotal();
  return (
    <div className="table-wrapper bordered-div m-4" style={{ flex: "1 1 0%", overflow: "auto", padding: "0px 24px 24px" }}>
      <h6 style={{ textAlign: "center", padding: "20px" }}>{title}</h6>
      <div
        className={`booking-list-data scroll ${
          isScrolling ? "show-scroll" : "no-scroll"
        }`}
        style={{ height: "auto" }}
      >
        <div className="table-responsive">
          <table className="display nowrap dataTable w-100">
            <thead>
              <tr>
                <th>
                  <span></span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("sub_activity", statusIsASC)}
                >
                  <span>{t("Translation.co2_footprint")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("needed_equipment", statusIsASC)}
                >
                  <span>{t("Translation.total_co2_footprint")}</span>
                </th>
                <th
                  className="sorting"
                  onClick={() => toggleSort("fuel_type", statusIsASC)}
                >
                  <span>{t("Translation.of_total_co2_emissions")}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.transport}</td>
                  <td>{row.footprint}</td>
                  <td>{row.totalfootprint}</td>
                  <td>{row.totalco2emission}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>{t("Translation.subtotal")}</td>
                <td>{subtotal.footprint}</td>
                <td>{subtotal.totalfootprint}</td>
                <td>{subtotal.totalco2emission}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
